__turbopack_context__.v({
  "dial": "glass-twin-module__xaVQha__dial",
  "dimension": "glass-twin-module__xaVQha__dimension",
  "instrument-note-enter": "glass-twin-module__xaVQha__instrument-note-enter",
  "instrumentNoteStep": "glass-twin-module__xaVQha__instrumentNoteStep",
  "particleStage": "glass-twin-module__xaVQha__particleStage",
  "registrationFrame": "glass-twin-module__xaVQha__registrationFrame",
  "source-flow-pulse": "glass-twin-module__xaVQha__source-flow-pulse",
  "sourceFlowPulse": "glass-twin-module__xaVQha__sourceFlowPulse",
});
